import React from 'react';

const Quote = () => {
	return(
		<div className='quotes-settings right-side-body'>
			<div className='options-heading'>
				<h1>Quotes</h1>
				<p>Find some inspiration</p>
			</div>
		</div>
		)
}

export default Quote